// الانتقال من المربع — the Morabaa import wizard of the customers module
// (HANDOFF-erp-web §3 «الاستيراد» `/customers/import`, §5.2; boards
// customers/import--source · --mapping · --preview · --done; step 4
// «تاريخ الانتقال» has no board and is built minimal).
//
// FOR THE INTEGRATOR — this folder does not register itself:
//   1. src/features/customers/index.tsx: spread `importRoutes` into `routes`
//      and `importMenu` into `menu` (last row, after «الملف الطبي»).
//   2. src/features/customers/mock/handlers.ts: spread `importHandlers`
//      (the mock bootstrap only discovers src/features/<module>/mock/handlers.ts).
//
// Server: erp-core `/v1/erp/import/*`, OWNER only (auth.RequireRole(RoleOwner))
// in both modes — the client hides the row and refuses the routes for
// staff/manager; the server enforces. The customers module's own flag
// (`erp.core`) removes everything with it; the items / suppliers / installments
// sheets are sent only when `erp.inventory` / `erp.installments` are on.

import type { RouteObject } from 'react-router-dom';
import { gate, type MenuItem } from '@/app/module-types';

export { importHandlers } from './mock/handlers';
export { IMPORT_BASE, stepPath } from './lib/text';

const screens = () => import('./screens/routes');
/** Every step: owner only (server: auth.RequireRole(RoleOwner)). */
const handle = gate({ minRole: 'owner' });

export const importRoutes: RouteObject[] = [
  { path: '/customers/import', handle, lazy: () => screens().then((m) => ({ Component: m.SourceRoute })) },
  { path: '/customers/import/mapping', handle, lazy: () => screens().then((m) => ({ Component: m.MappingRoute })) },
  { path: '/customers/import/preview', handle, lazy: () => screens().then((m) => ({ Component: m.PreviewRoute })) },
  { path: '/customers/import/cutover', handle, lazy: () => screens().then((m) => ({ Component: m.CutoverRoute })) },
  { path: '/customers/import/done', handle, lazy: () => screens().then((m) => ({ Component: m.DoneRoute })) },
];

export const importMenu: MenuItem[] = [{ key: 'import', label: 'الاستيراد', to: '/customers/import', minRole: 'owner' }];
